import { Route } from '@angular/router';
import { AppRoutePaths } from '@core/types/app-route-paths';
import {
  NoPermissionComponent,
  PersonRequiredComponent,
} from '@core/components';
import {
  canUseAppGuard,
  PermissionGuard,
  personRequiredGuard,
  personRequiredPageGuard,
} from '@core/guards';
import { userGuard } from '@core/guards/user.guard';
import { OutkeepPermission } from '@outkeep/shared';
import {
  DocflowComponent,
  PayrollComponent,
  ProfilePageComponent,
  RestrictedRequestViewComponent,
  WarehouseComponent,
} from './features';
import { HealthcheckComponent } from './features/healthcheck/healthcheck.component';

export const appRoutes: Route[] = [
  {
    path: AppRoutePaths.Healthcheck,
    component: HealthcheckComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AppRoutePaths.Requests,
  },
  {
    path: AppRoutePaths.RequestGuestView + '/:token',
    component: RestrictedRequestViewComponent,
  },
  {
    path: AppRoutePaths.PersonRequired,
    canActivate: [userGuard, personRequiredPageGuard],
    component: PersonRequiredComponent,
  },
  {
    path: '',
    canActivateChild: [userGuard, personRequiredGuard],
    children: [
      {
        path: AppRoutePaths.RequestView + '/:requestNumber',
        component: RestrictedRequestViewComponent,
      },
      {
        path: AppRoutePaths.NoPermission,
        component: NoPermissionComponent,
      },
      {
        path: AppRoutePaths.Requests,
        canActivate: [canUseAppGuard],
        loadChildren: () =>
          import('./features/requests/requests.routes').then(
            ({ requestsRoutes }) => requestsRoutes,
          ),
      },
      {
        path: AppRoutePaths.Profile,
        canActivate: [canUseAppGuard],
        component: ProfilePageComponent,
      },
      {
        path: AppRoutePaths.Payroll,
        canActivate: [canUseAppGuard, PermissionGuard],
        component: PayrollComponent,
        data: {
          permission: [OutkeepPermission.Payroll, OutkeepPermission.PayrollOn],
        },
      },
      {
        path: AppRoutePaths.Warehouse,
        canActivate: [canUseAppGuard, PermissionGuard],
        component: WarehouseComponent,
        data: {
          permission: [
            OutkeepPermission.Warehouse,
            OutkeepPermission.WarehouseOn,
          ],
        },
      },
      {
        path: AppRoutePaths.Docflow,
        canActivate: [canUseAppGuard, PermissionGuard],
        component: DocflowComponent,
        data: {
          permission: OutkeepPermission.LogistDocFlowOn,
        },
      },
      {
        path: AppRoutePaths.LogistTimeManagement,
        canMatch: [userGuard, personRequiredGuard, canUseAppGuard],
        loadChildren: () =>
          import('./features/logist-time-management/logist-time-management.routes').then(
            ({ logistTimeManagementRoutes }) => logistTimeManagementRoutes,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: AppRoutePaths.NoPermission,
    pathMatch: 'full',
  },
];
